import { DialogSearchComponent } from '@dialog/dialog-search/dialog-search.component';
import { ICheckListParams, IDialogSearchParams } from '@interfaces';
import { Subscription, Observable } from 'rxjs';
import { Component, OnInit, Input, Output, OnChanges, EventEmitter,
  ViewChild, SimpleChanges, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MatTableDataSource, MatPaginator,
  MatSort, MatDialog, MatSlideToggleChange } from '@angular/material';
import { Router } from '@angular/router';
import { UNFILTERED } from '@base/utils';

interface IRow {
  id: number;
  name: string;
  related: {
    status: boolean;
    disabled: boolean;
  };
  active: {
    status: boolean;
    disabled: boolean;
  };
}
@Component({
  selector: 'app-checklist-board',
  templateUrl: './checklist-board.component.html',
  styleUrls: ['./checklist-board.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckListBoardComponent implements OnInit, OnDestroy {
  private collectionSubs: Subscription;
  @Input() info: ICheckListParams;
  @Input() dataset: Observable<any>;
  @Output() itemsSelected = new EventEmitter();
  @ViewChild(MatPaginator) paginator:  MatPaginator;
  @ViewChild(MatSort) sort:  MatSort;
  public selectedOptions;
  public searchParams: IDialogSearchParams;

  dataSource: MatTableDataSource<IRow>;
  displayedColumns  = ['name', 'related', 'active', ];
  pageSize = 5;
  pageSizeOptions: number[];
  total = {
    active: 0,
    inactive: 0,
  };
  exclude = [];
  source = [];
  collection: IRow[];

  constructor(
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private router: Router,
  ) {
    this.collection = [];
    this.dataSource = new MatTableDataSource(this.collection);
  }

  ngOnInit() {
    this.pageSize = (!this.info.hasOwnProperty('pageSize')) ? 5 : this.info['pageSize'];
    this.pageSizeOptions = (!this.info.hasOwnProperty('pageSizeOptions')) ? [5, 10] : this.info['pageSizeOptions'];
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.exclude = this.info.searchParams.exclude;

    if (typeof this.info.searchParams.source === 'undefined') {
      this.info.searchParams.source = [];
    }

    this.collectionSubs = this.dataset.subscribe((data) => {
      this.cdr.markForCheck();
      this.collection = data;
      this.dataSource = new MatTableDataSource(this.collection);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.calculateTotal();
    });
  }

  ngOnDestroy() {
    if (typeof this.collectionSubs !== 'undefined') {
      this.collectionSubs.unsubscribe();
    }
  }

  addObject() {
    this.searchParams = this.info.searchParams;
    this.searchParams.exclude = this.collection;
    const dialogRef = this.dialog.open(DialogSearchComponent, {
      data: this.searchParams,
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe(associates => {
      if (typeof associates !== 'undefined') {
        associates.map((item: object) => {
          const newItem = {
            id: item['id'],
            name: item['name'],
            active: {
              status: this.info.autoActivate,
              disabled: false,
            },
            related: {
              status: true,
              disabled: false,
            },
          };
          this.collection.push(newItem);
          this.dataSource.data = this.collection;
          this.dataSource.paginator = this.paginator;
          this.calculateTotal();
          this.itemsSelected.emit(this.collection);
        });
      }
    });
  }

  calculateTotal() {
    const inactive = this.dataSource.data.filter((item) => item['active']['status'] === false).length;
    this.total.inactive = inactive;
    this.total.active = this.dataSource.data.length - inactive;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  updateRelatedOptions(event: MatSlideToggleChange, row: IRow) {
    const objIndex = this.collection.findIndex((obj => obj.id === row.id));
    const currentActiveStatus = this.collection[objIndex]['active']['status'];
    const currentActiveDisabled = this.collection[objIndex]['active']['disabled'];

    this.collection[objIndex]['related']['status'] = event.checked;
    this.collection[objIndex]['active']['disabled'] = !this.collection[objIndex]['related']['status'];

    if (!event.checked && (currentActiveStatus && !currentActiveDisabled)) {
      this.collection[objIndex]['active']['status'] = false;
    }

    this.itemsSelected.emit(this.collection);
  }

  updateActiveOptions(event: MatSlideToggleChange, row: IRow) {
    const objIndex = this.collection.findIndex((obj => obj.id === row.id));
    this.collection[objIndex]['active']['status'] = event.checked;
    this.calculateTotal();
    this.itemsSelected.emit(this.collection);
  }

  goToDetails(row: object) {
    const hasPermissions = (!this.info['locked'] && this.info.searchParams.filter !== UNFILTERED);
    if (hasPermissions) {
      const finalPath = `/home/${this.info.searchParams.filter}/`;
      localStorage.setItem('temp_url', this.router.url);
      this.router.navigate([`${finalPath}${row['id']}`]);
    }
  }
}
